import axios from "axios";
import { toast } from "react-toastify";

const jwtToken = localStorage.getItem("token");

export const publicRequest = axios.create({
  baseURL: URL,
});

export const userRequest = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: jwtToken ? `Bearer ${jwtToken}` : "",
  },
});

userRequest.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  config.headers.Accept = "application/json";
  return config;
}, (error) => {
  return Promise.reject(error);
});

userRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 401 || error.response?.data?.message === "Token is invalid!")) {
      toast.warn("Session Expired! Please Re-login");
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);
